export default "__VITE_ASSET__Bfa0mKyU__"